import { createAction, props } from "@ngrx/store";
import { ObjectF } from "../../models/formulas/object";

export const findObjectCatalogAct = createAction('findObjectCatalogEffect', props <{ id: number }>());
export const loadObjectCatalogByIdAct = createAction('loadObjectCatalogByIdEffect', props<{ object: ObjectF }>());

export const resetObjectCatalogAct = createAction('resetObjectCatalogEffect');

export const updateObjectCatalogAct = createAction('updateObjectCatalogEffect', props<{ objectUpdated: ObjectF }>());
export const updateSuccessObjectCatalogAct = createAction('updateSuccessObjectCatalogEffect', props<{ objectUpdated: ObjectF }>());

export const saveObjectCatalogAct = createAction('saveObjectCatalogEffect', props<{ objectNew: ObjectF }>());
export const saveSuccessObjectCatalogAct = createAction('saveSuccessObjectCatalogEffect', props<{ objectNew: ObjectF }>());

export const setViolationsObjectCatalogAct = createAction('setViolationsObjectCatalogEffect', props<{ objectForm: ObjectF, violations: {} }>());
export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );
